import type { LocalSettings } from "@app/config/LocalSettings";
import localSettings from "@app/config/LocalSettings";
import { MIN_LEGEND_HEIGHT } from "@app/scene/map/utils/consts";

class MapSettings {
  settings: LocalSettings;

  private readonly KEY_TOOLBAR_HEIGHT = "__KEY_TOOLBAR_HEIGHT__";

  constructor(settings: LocalSettings) {
    this.settings = settings;
  }

  getKeyToolbarHeight = (): number => {
    const height = localStorage.getItem(this.KEY_TOOLBAR_HEIGHT);
    if (!height) {
      return MIN_LEGEND_HEIGHT;
    } else {
      return JSON.parse(height);
    }
  };

  setKeyToolbarHeight = (height: number) => {
    localStorage.setItem(this.KEY_TOOLBAR_HEIGHT, JSON.stringify(height));
  };
}

const mapSettings = new MapSettings(localSettings);

export default mapSettings;
